import { render, staticRenderFns } from "./addVideo.vue?vue&type=template&id=2ba8b1dc&scoped=true&"
import script from "./addVideo.vue?vue&type=script&lang=js&"
export * from "./addVideo.vue?vue&type=script&lang=js&"
import style0 from "./addVideo.vue?vue&type=style&index=0&id=2ba8b1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8b1dc",
  null
  
)

export default component.exports